/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useRef, useState } from "react";

import { AxiosError } from "axios";
import Skeleton from "react-loading-skeleton";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { RootState } from "../../../app/store";
import { formatAndSetDataForOverallAnalysis } from "../../../utils/trendSidebarGraphUtils/overallAnalysisUtils";
import Dropdown from "../Dropdown";
import OverallAnalysisGraph from "./OverallAnalysisGraph";
import { useNavigate } from "react-router-dom";
import { BarData } from "../../../interface/Trends";

type Props = {
  trendFilterType: string;
  selectedMaterials?: string[];
  isBarGraphDataNotAvailable?: boolean;
};

const OverallAnalysisSidebar = ({
  trendFilterType,
  selectedMaterials,
  isBarGraphDataNotAvailable,
}: Props) => {
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const navigate = useNavigate();

  const [barData, setBarData] = useState<BarData[] | null>(null);

  const user = useSelector((state: RootState) => state.user.userInfo);
  const graphRevision = useSelector(
    (state: RootState) => state.trends.graphRevision ?? 0
  );

  const fetchBarGraphData = async () => {
    if (isBarGraphDataNotAvailable) {
      return;
    }
    try {
      setLoading(true);
      await formatAndSetDataForOverallAnalysis(
        trendFilterType,
        user,
        setBarData,
        () => {},
        "Trend Score"
      );
    } catch (error) {
      console.error("Error Fetching bar graph data", error);
      if ((error as AxiosError)?.response?.status !== 400) {
        toast.error("Error Fetching bar graph data");
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBarGraphData();
  }, [trendFilterType, graphRevision]);

  if ((barData && barData.length === 0) || isBarGraphDataNotAvailable) {
    return <div className="my-5 text-center">No Overall Analysis Data</div>;
  }

  return (
    <div className="mx-3 w-[410px]">
      <div
        className="absolute right-2 top-1 text-right text-xs underline font-bold cursor-pointer"
        onClick={() =>
          navigate("/designer-page/overall-analysis", {
            state: {
              trendFilterType,
              selectedMaterials,
            },
          })
        }
      >
        Expand
      </div>
      <div className="relative overflow-x-scroll scrollbar-custom">
        <div className="" ref={scrollContainerRef}>
          {!barData || loading ? (
            <div className="my-10 flex items-center justify-center">
              <Skeleton height={350} width={430} />
            </div>
          ) : (
            <OverallAnalysisGraph
              barData={barData}
              selectedMaterials={selectedMaterials}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default OverallAnalysisSidebar;
